interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'FAQPage' | 'Article';
  data?: Record<string, unknown>;
}

export default function SchemaOrg({ type, data = {} }: SchemaOrgProps) {
  const schemas: Record<string, Record<string, unknown>> = {
    Organization: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '奶泡动漫',
      url: 'https://naipadongman.com',
      logo: 'https://naipadongman.com/logo.png',
      description: '奶泡动漫是专注于高品质动漫内容的在线观看平台，提供海量日漫、国漫、番剧资源',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        email: 'contact@naipadongman.com',
        availableLanguage: ['Chinese'],
      },
      sameAs: [
        'https://weibo.com/naipadongman',
      ],
      ...data,
    },
    WebSite: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '奶泡动漫',
      url: 'https://naipadongman.com',
      description: '高品质动漫在线观看平台 - 海量日漫国漫番剧资源',
      inLanguage: 'zh-CN',
      ...data,
    },
    WebPage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '奶泡动漫',
      description: '高品质动漫在线观看平台',
      inLanguage: 'zh-CN',
      ...data,
    },
    FAQPage: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      ...data,
    },
    Article: {
      '@context': 'https://schema.org',
      '@type': 'Article',
      ...data,
    },
  };

  const schema = schemas[type] || schemas.WebPage;

  return (
    <script type="application/ld+json">
      {JSON.stringify(schema)}
    </script>
  );
}